export const dataPaygate = [
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-1231255',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :true,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :true,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :true,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :true,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :true,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
	{
		level: 'T1',
		caseType: 'Tempory Hold',
		caseId: 'PP-D-136530710',
		caseReason: 'enquiry',
		caseFillingDate: '2021/11/04 18:10:20',
		link: '',
		orderNumber: '#2341265-124556',
		sup: 'Zooto Bear',
		tkn: 'YT23112343534534523',
		agentNote: 'Active den 19/12',
		nextAction: 'Da nhan KH normal active',
		dueCase: '2021/11/09 09:26:10',
		csStage: 'Done',
        status :false,
	},
];
